import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Board } from '../../../core/board/board';
import { BoardFuncs } from '../../../core/board/board.func';
import { BoardIconComponent } from '../board-icon/board-icon.component';

@Component({
  selector: 'app-board-vertical-icon-title',
  standalone: true,
  imports: [CommonModule, BoardIconComponent],
  templateUrl: './board-vertical-icon-title.component.html',
  styleUrl: './board-vertical-icon-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardVerticalIconTitleComponent {
  @Input({ required: true }) board?: Board;

  @Input() selectable = false;
  @Input() isSelected = false;

  getBoardName(board?: Board) {
    if (!board) {
      return '';
    }

    return BoardFuncs.getNameWithoutFirstEmoji(board);
  }

  getClassList() {
    if (this.selectable && this.isSelected) {
      return ['selectable', 'is-selected'];
    } else if (this.selectable) {
      return ['selectable'];
    } else {
      return [];
    }
  }
}
